module.exports = __webpack_public_path__ + "img/Group 27920@2x.17cdd28a.png";